// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoContainer_YusVq video {
  pointer-events: none;
  background-color: #000000;
  height: 100%;
  width: 100%;
}

.videoContainer_YusVq {
  container-type: size;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-video/lib/player/mpegts/MpegTsPlayer.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".videoContainer video {\n  pointer-events: none;\n  background-color: #000000;\n  height: 100%;\n  width: 100%;\n}\n\n.videoContainer {\n  container-type: size;\n  position: relative;\n  -webkit-user-select: none;\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoContainer": `videoContainer_YusVq`
};
export default ___CSS_LOADER_EXPORT___;
